<template>
  <div class="municipio">
    <div class="municipio__actions">
      <div class="municipio__actions__voltar">
        <v-btn
          type="button"
          text
          class="municipio__actions__voltar--button"
          @click="$router.push(`/cidade/${municipio.municipioId}`)"
        >
          Voltar
        </v-btn>
      </div>
      <div class="municipio__actions__adicionar">
        <v-btn
          type="button"
          class="municipio__actions__adicionar--buttonAdd"
          @click="downloadPdf"
        >
          Download
        </v-btn>
        <v-btn
          type="button"
          class="municipio__actions__adicionar--button"
          @click="
            $router.push(
              `/cidade/${municipio.municipioId}/resumo-municipio/add`
            )
          "
        >
          Adicionar
        </v-btn>
      </div>
    </div>

    <v-card
      elevation="2"
      :class="{ 'justify-center': isGov }"
      class="municipio__header"
    >
      <div class="municipio__header__name">
        {{ municipio.nome }}
      </div>
      <template v-if="!isGov">
        <hr />
        <div class="municipio__header__contrato">
          <div class="municipio__header__contrato__periodo">
            Período contrato: {{ municipio.dataContrato }}
          </div>
          <div
            class="municipio__header__contrato__numContrato"
            v-if="municipio.numeroContrato"
          >
            Num Contr: {{ municipio.numeroContrato }}
          </div>
        </div>
      </template>
    </v-card>

    <v-card elevation="2" class="municipio__body" v-if="municipioResumo.length">
      <div
        class="municipio__body__items"
        v-for="municipioResumo in municipioResumoGroupBy"
        :key="municipioResumo.resumoId"
      >
        <div class="municipio__body__items__instituicao">
          {{ municipioResumo.name }}
        </div>

        <div
          class="municipio__body__items__dados"
          v-for="municipioResumoChildren in municipioResumo.children"
          :key="municipioResumoChildren.resumoId"
        >
          <v-col class="municipio__body__items__dados__foto" cols="2">
            <img
              v-if="municipioResumoChildren.foto"
              :src="`data:image/png;base64,${municipioResumoChildren.foto}`"
            />
          </v-col>
          <v-col class="municipio__body__items__dados__personal" cols="3">
            <div class="municipio__body__items__dados__personal__name">
              <div><strong>Nome:</strong></div>
              <span :title="municipioResumoChildren.nome">
                {{ municipioResumoChildren.nome }}</span
              >
            </div>

            <div
              class="municipio__body__items__dados__personal__funcao borderBetween"
            >
              <div><strong>Cargo:</strong></div>

              <span :title="municipioResumoChildren.cargo">{{
                municipioResumoChildren.cargo
              }}</span>
            </div>
          </v-col>
          <v-col class="municipio__body__items__dados__infos" cols="3">
            <div class="municipio__body__items__dados__infos__telefone">
              <div><strong>Telefone:</strong></div>
              <span :title="municipioResumoChildren.telefone">{{
                municipioResumoChildren.telefone
              }}</span>
            </div>
            <div
              class="municipio__body__items__dados__infos__email borderBetween"
            >
              <div><strong>Email:</strong></div>

              <span :title="municipioResumoChildren.email">{{
                municipioResumoChildren.email
              }}</span>
            </div>
          </v-col>
          <v-col
            class="municipio__body__items__dados__infos"
            cols="2"
            v-if="!isGov"
          >
            <div class="municipio__body__items__dados__infos__telefone">
              <div><strong>Perfil:</strong></div>
              <span
                :title="
                  perfis &&
                  perfis
                    .filter(
                      (item) =>
                        item.idMunicipioResumoPerfil ==
                        municipioResumoChildren.idMunicipioResumoPerfil
                    )
                    .map((val) => val.nome)[0]
                "
                >{{
                  perfis &&
                  perfis
                    .filter(
                      (item) =>
                        item.idMunicipioResumoPerfil ==
                        municipioResumoChildren.idMunicipioResumoPerfil
                    )
                    .map((val) => val.nome)[0]
                }}</span
              >
            </div>
          </v-col>
          <v-col class="municipio__body__items__dados__infos__actions">
            <v-btn
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/cidade/${municipio.municipioId}/resumo-municipio/add/${municipioResumoChildren.resumoId}`
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <modal-delete
              :payload="municipioResumoChildren"
              @onDelete="loadResumoMunicipio"
            ></modal-delete>
          </v-col>
        </div>
      </div>
    </v-card>

    <v-card v-if="!municipioResumo.length" class="municipio__nenhumDado">
      Nenhum dado retornado.
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { cityAPI } from "@/modules/city";
import moment from "moment";
import modalDelete from "./modalDelete.vue";
import { resumoMunicipioApi, resumoMunicipioPerfilApi } from "@/apis";

export default {
  components: {
    modalDelete,
  },
  data() {
    return {
      perfis: [],

      municipio: {},
      municipioResumo: [],
      municipioResumoGroupBy: [],
      municipioId: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters(["isSala", "isGov"]),
  },

  methods: {
    ...mapActions(["setLoading"]),
    downloadPdf() {
      this.setLoading(true);
      resumoMunicipioApi
        .downloadPdf(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          var nome = this.isGov
            ? "Atores_Projeto_"
            : !this.isSala
            ? "Atores_Municipio_"
            : "Resumo_Participante_";
          link.download =
            nome +
            this.municipio.nome +
            "_" +
            moment(resp.data.contratoInicio).format("DD_MM_YYYY_HH_mm") +
            ".pdf";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF");
        });
    },
    loadCity() {
      this.setLoading(true);

      cityAPI
        .get(this.$route.params.id)
        .then(({ data }) => {
          this.municipio = {
            ...data,
            dataContrato: ` ${moment(data.contratoInicio).format("MM/YYYY")} ${
              data.contratoFim
                ? "-" + moment(data.contratoFim).format("MM/YYYY")
                : ""
            } `,
          };
          this.loadResumoMunicipio();
        })
        .catch((resp) => {
          console.log("Erro ao obter município ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    async getResumoMunicipioPerfil() {
      try {
        const { data: resumiMunicipioPerfil } =
          await resumoMunicipioPerfilApi.list();
        this.perfis = resumiMunicipioPerfil;
      } catch (error) {
        console.log("error: ", error);
        this.$notification.error("Erro ao listar perfis do municipio");
      }
    },
    loadResumoMunicipio() {
      resumoMunicipioApi
        .list(this.$route.params.id)
        .then(({ data }) => {
          this.municipioResumo = data;

          let groupBy = this.municipioResumo.map((item) => {
            return {
              ...item,
              instituicao: !["MUNICIPIO", "SEBRAE"].includes(item.instituicao)
                ? "Participantes de OUTRAS INSTITUIÇÕES"
                : `Participantes do ${item.instituicao}`,
            };
          });

          let key = "instituicao";
          let aux = groupBy.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});

          this.municipioResumoGroupBy = Object.keys(aux).map((key) => {
            return {
              name: key,
              resumoId: aux[key][0].resumoId,
              children: aux[key],
            };
          });

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("Erro ao obter município ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
  },
  mounted() {
    this.loadCity();
    this.getResumoMunicipioPerfil();
  },
};
</script>
<style lang="scss" scoped>
.municipio {
  max-width: 932px;
  margin: 2rem auto 0px auto;
  text-transform: uppercase;

  hr {
    width: 50px;
    transform: rotate(91deg);
  }

  .borderBetween {
    border-top: 1px solid #00000017;
    padding-top: 5px;
    margin-top: 5px;
  }

  &__header {
    display: flex;
    background: var(--corPrimaria);
    color: #fff;
    padding: 1rem;
    align-items: center;
    &__contrato {
      &__periodo {
        color: #fff;
      }
      &__numContrato {
        color: #fff;
      }
    }
    &__name {
      padding: 0px 1rem 0px 1rem;
    }
  }
  &__body {
    padding: 1rem 0px;
    &__items {
      font-size: 14px;
      &:not(:last-of-type) {
        border-bottom: 2px solid var(--corPrimaria);
      }
      &__instituicao {
        margin: 1rem 0px;
        text-align: center;
        font-weight: bold;
      }
      &__dados {
        display: flex;
        margin-bottom: 1rem;
        justify-content: space-around;
        padding: 1rem 0;
        align-items: center;

        span {
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        &:nth-child(even) {
          background: #ededed8f;
        }
        &__foto {
          display: flex;
          justify-content: center;
          img {
            width: 80%;
            border-radius: 50%;
            min-width: 80px;
          }
        }
        &__infos {
          &__actions {
            justify-content: flex-end;
            display: flex;
          }
        }
      }
    }
  }

  &__actions {
    display: flex;
    &__voltar {
      &--button {
        color: var(--corPrimaria);
      }
    }
    &__adicionar {
      margin-bottom: 1rem;
      display: flex;
      column-gap: 1rem;
      margin-left: auto;
      &--button {
        background-color: var(--corPrimaria) !important;
        color: #fff;
      }
      &--buttonAdd {
        border: 1px solid var(--corPrimaria) !important;
        color: var(--corPrimaria);
      }
    }
  }

  &__nenhumDado {
    text-align: center;
    padding: 1rem;
  }
}
</style>
